import { BusinessCommentUpdate } from '@/entities/business';
import { BusinessService } from '@/services/BusinessService';
import { useState } from 'react';

const useComments = () => {
  const [ isEditComment, setIsEditComment ] = useState(false);
  const [ errorUpdateBusinessComment, setErrorUpdateBusinessComment] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const updateComment = async (id: number, comment: BusinessCommentUpdate) => {
    try{
      const response = await BusinessService.updateBusinessComment(id, comment);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim!\n', e);
      setErrorUpdateBusinessComment(true);
    }
  };

  return {
    isEditComment,
    deleteOpen,
    setIsEditComment,
    updateComment,
    setDeleteOpen
  };

};

export default useComments;
